import {
    EpgProgram,
    MixedItem,
    RBProgram,
    SearchProgram,
} from 'store/railsBuilder/reducer.types';
import { RecordingMetadata } from 'store/recordings/reducer.types';

import getOpeningParams from './getOpeningParams';

export default function getDeepLinkProviderValues(
    item: EpgProgram | RBProgram | MixedItem | SearchProgram,
): {
    deeplinkProviderId: string;
    providerResourceId: string;
} {
    const { link } = getOpeningParams(item);

    const deeplinkProviderId = link?.provider || '';
    const providerResourceId =
        'editorial' in item && 'companyId' in item.editorial!
            ? item.editorial!.companyId || ''
            : '';

    return {
        deeplinkProviderId,
        providerResourceId,
    };
}
